import React from 'react'
import { Box } from '@mui/material'
import { GRID_COLUMNS, PanelSpan, gridColumnFor } from './spans'

const templateFor = (columns: number) => `repeat(${columns}, minmax(0, 1fr))`

const DashboardGrid = React.forwardRef<HTMLDivElement, { children: React.ReactNode }>(({ children }, ref) => (
  <Box
    ref={ref}
    sx={{
      display: 'grid',
      gridTemplateColumns: {
        xs: templateFor(GRID_COLUMNS.xs),
        md: templateFor(GRID_COLUMNS.md),
        lg: templateFor(GRID_COLUMNS.lg),
      },
      columnGap: { xs: 2, md: 2.5 },
      rowGap: 3,
      alignItems: 'stretch',
    }}
  >
    {children}
  </Box>
))
DashboardGrid.displayName = 'DashboardGrid'

type GridItemProps = {
  span: PanelSpan
  children: React.ReactNode
  // A DOM `style`, not `sx`: it changes every pointer move, and emotion would inject a class per value.
  style?: React.CSSProperties
}

export const GridItem = React.forwardRef<HTMLDivElement, GridItemProps>(({ span, children, style }, ref) => (
  <Box
    ref={ref}
    style={style}
    sx={{
      gridColumn: gridColumnFor(span),
      minWidth: 0,
      display: 'flex',
      position: 'relative',
      '&:hover .AdvancedResizeGrip': { opacity: 1 },
    }}
  >
    {children}
  </Box>
))
GridItem.displayName = 'GridItem'

export default DashboardGrid
